<template>
  <v-card outlined>
    <v-toolbar color="secondary" dark dense flat>
      <v-spacer />
      <v-select
        v-model="selectedContext"
        :disabled="isLoading"
        :items="mappedContext"
        :loading="isLoading"
        class="flex-grow-0 context-input"
        item-text="key"
        label="Select"
        dense
        hide-details
        solo
      />
    </v-toolbar>
    <component
      :is="child.name"
      v-for="child in component.children"
      :key="child.model"
      class="pa-2"
      v-bind="child.props"
      :value="value[selectedContext]"
      @input="onUpdate"
    />
  </v-card>
</template>

<script>
import { merge } from 'lodash-es'
import TextareaInput from '@/components/forms/textarea-input'
import FroalaInput from '@/components/forms/froala-input'

export default {
  name: 'SubcontextContainer',
  components: { TextareaInput, FroalaInput },
  props: {
    label: {
      type: String,
      default: undefined,
    },
    component: {
      type: Object,
      default: () => ({}),
    },
    data: {
      type: Object,
      default: () => ({}),
    },
    items: {
      type: Array,
      default: () => [],
    },
    offers: {
      type: Array,
      default: () => [],
    },
    isDisabled: {
      type: Boolean,
      default: false,
    },
    isLoading: {
      type: Boolean,
      default: false,
    },
    siteGroups: {
      type: Array,
      default: () => [],
    },
    value: {
      type: Object,
      default: () => {},
    },
  },
  data: () => ({
    selectedContext: 0,
  }),
  computed: {
    contextItems() {
      const context = this.component.subContext
      switch (context) {
        case 'siteGroup':
          return this.siteGroups
        default:
          return []
      }
    },
    contextLabel() {
      const context = this.component.subContext
      switch (context) {
        case 'siteGroup':
          return 'Site Group'
        default:
          return ''
      }
    },
    mappedContext() {
      const defaultItems = [{ key: `Default ${this.contextLabel}`, value: 0 }]
      return defaultItems.concat(this.contextItems.map(({ id, name }) => ({ key: name, value: id })))
    },
    valueForSelectedContext() {
      return this.value[this.selectedContext]
    },
  },
  watch: {
    selectedContext: {
      immediate: true,
      handler(selectedContext) {
        if (typeof this.value !== 'object' || typeof this.value[selectedContext] === 'undefined') this.onUpdate('')
      },
    },
  },
  methods: {
    onUpdate(event) {
      const merged = merge({}, this.value, { [this.selectedContext]: event })
      this.$emit('input', merged)
    },
  },
}
</script>
